import { Directive, OnInit, TemplateRef, ViewContainerRef } from '@angular/core';
import { NativeAppService } from '@shared/common/services/native-app/native-app.service';

@Directive({
  selector: '[appHideOnNativeApp]',
  standalone: false
})
export class HideOnNativeAppDirective implements OnInit {
  constructor(
    private readonly templateRef: TemplateRef<any>,
    private readonly viewContainer: ViewContainerRef,
    private readonly nativeAppService: NativeAppService
  ) {}

  ngOnInit(): void {
    if (this.nativeAppService.isNativeApp()) {
      this.viewContainer.clear();
      return;
    }
    this.viewContainer.createEmbeddedView(this.templateRef);
  }
}
